// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"9d080f7198c230673a5f","263":"3fb496d778d296d8f6dd","791":"0f0895f6375ff2650bc1"}[chunkId] + ".js";
};